<script>
  import { navigateTo } from 'svelte-router-spa';

  export let customer;

  function navigateCustomerPage(customer) {
    navigateTo(`/customer/${customer._id}`);
  }
</script>

<tr on:click={navigateCustomerPage(customer)}>
  <td>{customer.phoneNumber}</td>
  <td>{customer.name}</td>
  <td>{customer.district}</td>
  <td>{new Date(customer.callDate).toLocaleDateString()}</td>
</tr>
